export default {
  // List page
  '宣传页配置': 'Promotion Page Configuration',
  '类型': 'Type',
  '全部': 'All',
  '线上赛': 'Online Competition',
  '组织测试': 'Organized Test',
  '运动会': 'Sports Meet',
  '视频': 'Video',
  '图片': 'Image',
  '链接': 'Link',
  '发布时间': 'Publish Time',
  '状态': 'Status',
  '搜索': 'Search',
  '请输入标题搜索': 'Enter title to search',
  '查询': 'Query',
  '重置': 'Reset',
  '新增': 'Add',
  '标题': 'Title',
  '预览图': 'Preview Image',
  '关联对象': 'Associated Object',
  '排序': 'Sort',
  '创建人': 'Creator',
  '创建时间': 'Create Time',
  '发布人': 'Publisher',
  '暂无图片': 'No image',
  '操作': 'Action',
  '编辑': 'Edit',
  '删除': 'Delete',
  '启用': 'Enable',
  '停用': 'Disable',
  '确认要停用': 'Confirm to disable',
  '确认要停用{name}': 'Confirm to disable {name}?',
  '确认要删除': 'Confirm to delete',
  '确认要删除{name}吗？': 'Confirm to delete {name}?',
  '吗？': '?',
  '删除成功！': 'Deleted successfully!',
  '知道了': 'OK',
  '本机构资源空间已不足，请及时联系运营人员': 'Insufficient resource space, please contact the operation staff',

  // Add/Edit page
  '基本信息': 'Basic Information',
  '请输入标题': 'Enter title',
  '请选择类型': 'Select type',
  '请选择关联对象': 'Select associated object',
  '内容设置': 'Content Settings',
  '封面图': 'Cover Image',
  '支持jpg_jpeg_png格式，建议比例为16：9，最大不超过5M': 'Support jpg/jpeg/png format, recommended 16:9 ratio, maximum 5M',
  '视频列表': 'Video List',
  '支持mp4格式，最多上传5个视频': 'Support MP4/AVI/WMV format, recommended 16:9 ratio, maximum 500M, up to 5',
  '图片列表': 'Image List',
  '支持jpg_jpeg_png格式，建议比例为16：9，最大不超过20M，最多10张': 'Support jpg/jpeg/png format, recommended 16:9 ratio, maximum 20M, up to 10',
  '链接地址': 'Link URL',
  '请输入链接地址': 'Enter link URL',
  '请输入可用链接': 'Enter a valid link',
  '发布设置': 'Publish Settings',
  '请输入排序': 'Enter sort number',
  '发布': 'Publish',
  '返回': 'Back',
  '是否返回上一页？': 'Return to previous page?',
  '编辑成功': 'Edited successfully',
  '新增成功': 'Added successfully',
  '加载数据失败：': 'Failed to load data: ',
  '请上传封面图': 'Please upload cover image',
  '请上传视频': 'Please upload video',
  '请上传图片': 'Please upload image',
}
